import { useState, useEffect } from "react"
import bgImage from './img/batiments-de-la-ville-indienne.jpg'

const FormQuestion = () => {
    // Ajouter un style global pour empêcher le scroll automatique
    useEffect(() => {
        const style = document.createElement('style')
        style.textContent = `
            html {
                scroll-behavior: auto !important;
            }
            * {
                scroll-behavior: auto !important;
            }
        `
        document.head.appendChild(style)
        return () => document.head.removeChild(style)
    }, [])

    const [displayFormUser, setDisplayFormUser] = useState(true)
    const [isLoading, setIsLoading] = useState(false)
    
    // Initialiser avec les données stockées en mémoire
    const [formData, setFormData] = useState({
        previousOciRequest: '',
        previousOciCancelled: '',
        pakistaniBangladeshi: '',
        familyPakistaniBangladeshi: '',
        militaryService: '',
        militaryTraining: '',
        currentMilitaryService: '',
        nationalityAcquisition: '',
        nationalityDate: '',
        asylumRequest: '',
        convicted: '',
        familyInIndia: '',
        deportedExpelled: '',
        organizationAssociation: '',
        humanTrafficking: '',
        terrorism: '',
        terroristViews: '',
        criminalProceedings: '',
        criminalDetails: '',
        underInvestigation: '',
        wantedQuestioning: ''
    })
    
    const [errors, setErrors] = useState({})

    const requiredFields = [
        'previousOciRequest', 'previousOciCancelled', 'pakistaniBangladeshi', 
        'familyPakistaniBangladeshi', 'militaryService', 'militaryTraining', 
        'currentMilitaryService', 'nationalityAcquisition', 'nationalityDate',
        'asylumRequest', 'convicted', 'deportedExpelled', 'organizationAssociation',
        'humanTrafficking', 'terrorism', 'terroristViews', 'criminalProceedings',
        'underInvestigation', 'wantedQuestioning'
    ]

    // Fonction pour gérer les changements d'input
    const handleInputChange = (field, value) => {
        const newFormData = {
            ...formData,
            [field]: value
        };
        
        setFormData(newFormData);
        
        // Sauvegarder dans localStorage
        localStorage.setItem('oci-form-data', JSON.stringify(newFormData));
        
        // Clear error when field is filled
        if (errors[field] && value) {
            setErrors(prev => ({
                ...prev,
                [field]: ''
            }))
        }
    }

    const validateForm = () => {
        const newErrors = {}
        
        requiredFields.forEach(field => {
            if (!formData[field]) {
                newErrors[field] = 'Ce champ est obligatoire'
            }
        })

        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
      
        setIsLoading(true);
      
        const folderId = localStorage.getItem("dossierId");
        const firstName = localStorage.getItem("firstName");
        const lastName = localStorage.getItem("lastName");

        // Récupération propre des images
        const identityDocs = JSON.parse(localStorage.getItem("identity-cards") || "[]");
        const passports    = JSON.parse(localStorage.getItem("passports") || "[]");
        const signatures   = JSON.parse(localStorage.getItem("signatures") || "[]");
      
        const payload = {
            folderId,
            formData,
            firstName,
            lastName,
            images: {
              identityDocs,
              passports,
              signatures
            },
        };
      
        try {
          const res = await fetch("https://script.google.com/macros/s/AKfycbzV5ZNBvshPn4B2KPMdhLqoII7tI0dVmObWQ2Hjh1OGhTKUENglXXd5N9iqp-hUA-pr/exec", {
            method: "POST",
            headers: { "Content-Type": "application/json; charset=UTF-8" },
            body: JSON.stringify(payload),
            mode: "no-cors"
          });
      
          const text = await res.text();
          const result = JSON.parse(text);
          console.log("Résultat :", result);
          setDisplayFormUser(false);
        } catch (err) {
          console.error("Erreur :", err);
        } finally {
          setIsLoading(false);
          setDisplayFormUser(false);
        }
      };
      
    
      

    const RadioGroup = ({ name, value, onChange, error }) => {
        return (
            <div className="flex flex-col sm:flex-row gap-4">
                <label className="flex items-center cursor-pointer select-none">
                    <input 
                        type="radio" 
                        name={name}
                        value="oui"
                        checked={value === 'oui'}
                        onChange={() => onChange('oui')}
                        className="mr-2 w-4 h-4 text-blue-600 dark:text-blue-400"
                    />
                    <span className="text-gray-700 dark:text-gray-300">Oui</span>
                </label>
                <label className="flex items-center cursor-pointer select-none">
                    <input 
                        type="radio" 
                        name={name}
                        value="non"
                        checked={value === 'non'}
                        onChange={() => onChange('non')}
                        className="mr-2 w-4 h-4 text-blue-600 dark:text-blue-400"
                    />
                    <span className="text-gray-700 dark:text-gray-300">Non</span>
                </label>
                {error && <p className="text-red-500 dark:text-red-400 text-sm mt-1">{error}</p>}
            </div>
        )
    }

    // 1) Affiche un spinner si isLoading
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
        <div className="flex flex-col items-center">
          {/* Cercle animé */}
          <svg className="w-16 h-16 text-blue-600 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
          </svg>
          <p className="mt-4 text-gray-700 dark:text-gray-300">Envoi en cours… <br /> Veuillez Patientez.</p>
        </div>
      </div>
    )
  }

  // 2) Si la soumission a réussi
  if (!displayFormUser) {
    localStorage.clear();
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 dark:from-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8 text-center max-w-md">
          <div className="w-16 h-16 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">Formulaire soumis avec succès!</h2>
          <p className="text-gray-600 dark:text-gray-300">
            Vos informations ont bien été enregistrées.<br/><br/>
            Vous pouvez fermer cette page.
          </p>
        </div>
      </div>
    )
  }


    return (
        <div className="min-h-screen bg-cover bg-center py-8 px-4" style={{scrollBehavior: 'auto', backgroundImage: `url(${bgImage})` }}>
            <div className="max-w-4xl mx-auto">
                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                    {/* Header */}
                    <div className="bg-gradient-to-r from-orange-600 to-green-600 dark:from-orange-600 dark:to-green-700 px-6 py-8 text-white">
                        <h1 className="text-2xl md:text-3xl font-bold text-center">
                            Demande de Carte OCI (Overseas Citizen of India)
                        </h1>
                        <p className="text-center mt-2 text-blue-100 dark:text-blue-200">
                            Veuillez remplir toutes les informations ci-dessous
                        </p>
                    </div>

                    <div className="p-6 md:p-8" style={{scrollBehavior: 'auto'}}>
                        <form onSubmit={handleSubmit} style={{scrollBehavior: 'auto'}}>
                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous déjà demandé l'enregistrement d'une carte OCI pour vous-même?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="previousOciRequest"
                                    value={formData.previousOciRequest}
                                    onChange={(value) => handleInputChange('previousOciRequest', value)}
                                    error={errors.previousOciRequest}
                                />
                                {errors.previousOciRequest && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.previousOciRequest}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous rendu/fait annuler votre précédente carte OCI ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="previousOciCancelled"
                                    value={formData.previousOciCancelled}
                                    onChange={(value) => handleInputChange('previousOciCancelled', value)}
                                    error={errors.previousOciCancelled}
                                />
                                {errors.previousOciCancelled && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.previousOciCancelled}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous été citoyen pakistanais ou bangladais ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="pakistaniBangladeshi"
                                    value={formData.pakistaniBangladeshi}
                                    onChange={(value) => handleInputChange('pakistaniBangladeshi', value)}
                                    error={errors.pakistaniBangladeshi}
                                />
                                {errors.pakistaniBangladeshi && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.pakistaniBangladeshi}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    L'un de vos parents, grands-parents ou arrière-grands-parents était-il citoyen pakistanais ou bangladais ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="familyPakistaniBangladeshi"
                                    value={formData.familyPakistaniBangladeshi}
                                    onChange={(value) => handleInputChange('familyPakistaniBangladeshi', value)}
                                    error={errors.familyPakistaniBangladeshi}
                                />
                                {errors.familyPakistaniBangladeshi && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.familyPakistaniBangladeshi}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous travaillé dans les forces armées, paramilitaires, police, services de sécurité ou de renseignement ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">(ne concerne pas les enfants mineurs)</p>
                                <RadioGroup 
                                    name="militaryService"
                                    value={formData.militaryService}
                                    onChange={(value) => handleInputChange('militaryService', value)}
                                    error={errors.militaryService}
                                />
                                {errors.militaryService && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.militaryService}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous suivi une conscription/formation militaire/policière/nationale obligatoire ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="militaryTraining"
                                    value={formData.militaryTraining}
                                    onChange={(value) => handleInputChange('militaryTraining', value)}
                                    error={errors.militaryTraining}
                                />
                                {errors.militaryTraining && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.militaryTraining}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Êtes-vous toujours en service dans les forces armées/policières ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">(au-delà de la période de formation obligatoire, ne s'applique pas aux enfants mineurs)</p>
                                <RadioGroup 
                                    name="currentMilitaryService"
                                    value={formData.currentMilitaryService}
                                    onChange={(value) => handleInputChange('currentMilitaryService', value)}
                                    error={errors.currentMilitaryService}
                                />
                                {errors.currentMilitaryService && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.currentMilitaryService}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Mode d'acquisition de la nationalité actuelle
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <select 
                                    value={formData.nationalityAcquisition}
                                    onChange={(e) => handleInputChange('nationalityAcquisition', e.target.value)}
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                                >
                                    <option value="">Sélectionner...</option>
                                    <option value="naissance">Naissance</option>
                                    <option value="ascendance">Ascendance</option>
                                    <option value="mariage">Enregistrement</option>
                                    <option value="naturalisation">Naturalisation</option>
                                </select>
                                {errors.nationalityAcquisition && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.nationalityAcquisition}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Date d'acquisition de la nationalité actuelle
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <input 
                                    type="text"
                                    value={formData.nationalityDate}
                                    onChange={(e) => handleInputChange('nationalityDate', e.target.value)}
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                                />
                                {errors.nationalityDate && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.nationalityDate}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous déjà demandé l'asile (politique ou autre) avant d'obtenir la nationalité ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="asylumRequest"
                                    value={formData.asylumRequest}
                                    onChange={(value) => handleInputChange('asylumRequest', value)}
                                    error={errors.asylumRequest}
                                />
                                {errors.asylumRequest && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.asylumRequest}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous déjà été condamné par un tribunal ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="convicted"
                                    value={formData.convicted}
                                    onChange={(value) => handleInputChange('convicted', value)}
                                    error={errors.convicted}
                                />
                                {errors.convicted && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.convicted}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Informations sur les membres de votre famille résidant en Inde
                                </h2>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">(Nom, Adresse, Lien de parenté, Âge)</p>
                                <textarea 
                                    value={formData.familyInIndia}
                                    onChange={(e) => handleInputChange('familyInIndia', e.target.value)}
                                    placeholder="Votre réponse..."
                                    rows="4"
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-vertical bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                                />
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous déjà été refoulé/expulsé par un pays, y compris l'Inde ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="deportedExpelled"
                                    value={formData.deportedExpelled}
                                    onChange={(value) => handleInputChange('deportedExpelled', value)}
                                    error={errors.deportedExpelled}
                                />
                                {errors.deportedExpelled && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.deportedExpelled}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous été associé à une organisation accusée de violation des droits ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="organizationAssociation"
                                    value={formData.organizationAssociation}
                                    onChange={(value) => handleInputChange('organizationAssociation', value)}
                                    error={errors.organizationAssociation}
                                />
                                {errors.organizationAssociation && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.organizationAssociation}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous été impliqué dans la traite des êtres humains, trafic de drogue, maltraitance d'enfants, etc. ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="humanTrafficking"
                                    value={formData.humanTrafficking}
                                    onChange={(value) => handleInputChange('humanTrafficking', value)}
                                    error={errors.humanTrafficking}
                                />
                                {errors.humanTrafficking && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.humanTrafficking}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous participé à des actes de terrorisme, sabotage, espionnage, etc. ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="terrorism"
                                    value={formData.terrorism}
                                    onChange={(value) => handleInputChange('terrorism', value)}
                                    error={errors.terrorism}
                                />
                                {errors.terrorism && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.terrorism}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Avez-vous exprimé des opinions justifiant la violence terroriste ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="terroristViews"
                                    value={formData.terroristViews}
                                    onChange={(value) => handleInputChange('terroristViews', value)}
                                    error={errors.terroristViews}
                                />
                                {errors.terroristViews && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.terroristViews}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Y a-t-il des poursuites pénales engagées contre vous ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="criminalProceedings"
                                    value={formData.criminalProceedings}
                                    onChange={(value) => handleInputChange('criminalProceedings', value)}
                                    error={errors.criminalProceedings}
                                />
                                {errors.criminalProceedings && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.criminalProceedings}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Si oui, précisez les détails
                                </h2>
                                <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">(Date, Lieu, Nature, Issue de la procédure)</p>
                                <input 
                                    type="text"
                                    value={formData.criminalDetails}
                                    onChange={(e) => handleInputChange('criminalDetails', e.target.value)}
                                    placeholder="Votre réponse..."
                                    className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400"
                                />
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Faites-vous actuellement l'objet d'une enquête ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="underInvestigation"
                                    value={formData.underInvestigation}
                                    onChange={(value) => handleInputChange('underInvestigation', value)}
                                    error={errors.underInvestigation}
                                />
                                {errors.underInvestigation && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.underInvestigation}</p>}
                            </div>

                            <div className="mb-6 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                                <h2 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">
                                    Êtes-vous recherché pour interrogatoire ?
                                    <span className="text-red-500 dark:text-red-400 ml-1">*</span>
                                </h2>
                                <RadioGroup 
                                    name="wantedQuestioning"
                                    value={formData.wantedQuestioning}
                                    onChange={(value) => handleInputChange('wantedQuestioning', value)}
                                    error={errors.wantedQuestioning}
                                />
                                {errors.wantedQuestioning && <p className="text-red-500 dark:text-red-400 text-sm mt-2 font-medium">{errors.wantedQuestioning}</p>}
                            </div>

                            <button 
                                type="submit"
                                className="w-full bg-gradient-to-r  from-orange-600 to-green-600 text-white py-4 px-8 rounded-lg font-semibold text-lg hover:from-orange-700 hover:to-green-700 dark:hover:from-orange-700 dark:hover:to-green-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
                            >
                                Soumettre le formulaire
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FormQuestion